import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ScheduledContributionStatus } from '../ScheduledContribution.types';

import { SCHEDULED_CONTRIBUTION_QUERY_KEY } from './useScheduledContributionList.query';

interface Payload {
  id: string;
  status: ScheduledContributionStatus;
}
interface Params {
  onSuccess: () => void;
}

const useUpdateStatusScheduledContributionQuery = ({ onSuccess }: Params) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    (payload: Payload) =>
      api.patch(`${API_URL.SCHEDULED_CONTRIBUTIONS}/${payload.id}/status`, undefined, {
        params: {
          status: payload.status,
        },
      }),
    {
      onSuccess: () => {
        onSuccess();
      },
    }
  );

  const invalidateQueries = () => {
    queryClient.invalidateQueries({
      queryKey: [SCHEDULED_CONTRIBUTION_QUERY_KEY],
    });
  };

  return {
    isLoading: isLoading,
    isSuccess: isSuccess,
    handleSave: mutateAsync,
    invalidateQueries,
  };
};
export default useUpdateStatusScheduledContributionQuery;
